import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae7c958a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container mt-5" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_5 = { class: "login-card" }
const _hoisted_6 = { class: "login-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 col-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "top_title" }, " Welcome, ", -1))
const _hoisted_10 = { class: "top_title_2" }
const _hoisted_11 = { class: "form-group mt-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "user_email",
  class: "font-grey"
}, "Email ID", -1))
const _hoisted_13 = { class: "form-group mt-5" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "user_password",
  class: "font-grey"
}, "Password", -1))
const _hoisted_15 = { class: "col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-3 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3" }
const _hoisted_16 = { class: "row justify-content-center mx-md-0 mx-1 mb-5" }
const _hoisted_17 = { class: "col-md-12 col-12 px-1" }
const _hoisted_18 = { class: "text-muted text-right mt-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "subBtn",
  type: "submit",
  class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
}, " Sign In ", -1))
const _hoisted_20 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "modal-dialog" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Please fix this", -1))
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = {
  key: 0,
  ref: "errorBlock",
  id: "errorBlock"
}
const _hoisted_27 = {
  class: "modal fade",
  id: "pendingApprovalModal",
  tabindex: "-1",
  "aria-labelledby": "pendingApprovalModalLabel",
  "aria-hidden": "true"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_29 = { class: "modal-content pending-approval-modal" }
const _hoisted_30 = { class: "modal-header border-0" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "modal-body px-5 py-4" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"approval-icon-container text-center mb-4\" data-v-ae7c958a><div class=\"approval-icon\" data-v-ae7c958a><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#4CAF50\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-ae7c958a><path d=\"M22 11.08V12a10 10 0 1 1-5.93-9.14\" data-v-ae7c958a></path><polyline points=\"22 4 12 14.01 9 11.01\" data-v-ae7c958a></polyline></svg></div></div><h1 class=\"approval-title\" data-v-ae7c958a>Your Account Is Pending Approval</h1><div class=\"approval-content\" data-v-ae7c958a><p data-v-ae7c958a>Thank you for creating an account with Caprock.</p><p data-v-ae7c958a>Your credentials have been successfully verified, and your application is now under review. Our team is currently assessing your details to ensure everything is set up correctly.</p><p data-v-ae7c958a>Once your application has been approved and finalised, you will receive a confirmation email and full access to the Caprock platform will be activated automatically.</p><p data-v-ae7c958a>We appreciate your patience during this process.</p><p class=\"mb-0\" data-v-ae7c958a>If you have any questions in the meantime, please contact us at <a href=\"mailto:support@caprock.com.au\" class=\"support-link\" data-v-ae7c958a>support@caprock.com.au</a>.</p></div>", 3)
const _hoisted_37 = { class: "text-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Form, {
          method: "POST",
          action: "/",
          class: "my-1",
          onSubmit: _ctx.submitForm
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("p", _hoisted_10, [
                          _createTextVNode(" Sign In to Continue "),
                          _createVNode(_component_router_link, {
                            class: "reg_title",
                            to: "/sign-up"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" New to caprock portal ? ")
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.form.user_email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.user_email) = $event)),
                        placeholder: "ie. example@mail.com",
                        class: "form-control selected-field",
                        name: "user_email",
                        id: "user_email",
                        type: "text",
                        rules: _ctx.validateEmail
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_ErrorMessage, {
                        style: {"color":"#d00000"},
                        name: "user_email"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.form.user_password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.user_password) = $event)),
                        placeholder: "ie.. Your password here",
                        class: "form-control selected-field",
                        name: "user_password",
                        id: "user_password",
                        type: "password",
                        rules: _ctx.requiredField
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_ErrorMessage, {
                        style: {"color":"#d00000"},
                        name: "user_password"
                      })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_router_link, {
                        class: "success fp_title",
                        to: "/forgot-password"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Forgot Password ? ")
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_19
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal('exampleModal'))),
              class: "btn btn-secondary",
              "data-mdb-dismiss": "modal"
            }, " Close ")
          ]),
          _createElementVNode("div", _hoisted_25, [
            (_ctx.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "alert alert-danger"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal('pendingApprovalModal'))),
              class: "btn-close-custom",
              "aria-label": "Close"
            }, _hoisted_32)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal('pendingApprovalModal'))),
                class: "btn btn-primary btn-lg px-5"
              }, "Got It")
            ])
          ])
        ])
      ])
    ])
  ], 64))
}